interface Props {
  label: string;
  min: number;
  max: number;
  step: number;
  value: number;
  onChange: (v: number) => void;
}

/**
 * Ползунок с делениями.
 *
 * Ползунок бегает не по всей ширине, а по (ширина − диаметр бегунка):
 * его центр не может выйти за края дорожки. Если подписи разложить
 * по всей ширине, они разъедутся с бегунком — сильнее всего у краёв.
 * Поэтому подписи лежат в блоке, ужатом на половину бегунка с каждой
 * стороны, и позиционируются процентом от значения.
 */
export default function Slider({ label, min, max, step, value, onChange }: Props) {
  const ticks: number[] = [];
  for (let v = min; v <= max + 1e-9; v += step) {
    ticks.push(Math.round(v * 1000) / 1000);
  }

  const pct = (v: number) => ((v - min) / (max - min)) * 100;

  return (
    <div className="field">
      <div className="row" style={{ marginBottom: 4 }}>
        <label style={{ marginBottom: 0 }}>{label}</label>
        <span className="badge" style={{ minWidth: 42, textAlign: 'center' }}>
          {value}
        </span>
      </div>

      <div className="slider">
        <input
          className="slider__input"
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          style={{ '--fill': `${pct(value)}%` } as React.CSSProperties}
        />

        <div className="slider__ticks">
          {ticks.map((t) => (
            <button
              key={t}
              type="button"
              className={`slider__tick ${t === value ? 'is-active' : ''}`}
              style={{ left: `${pct(t)}%` }}
              onClick={() => onChange(t)}
            >
              {t}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
